import React, { useEffect, useState } from 'react';
import axios from 'axios';
import Swal from 'sweetalert2';
import AdminSearch from '../components/AdminSearch.js';

const AdminSubjects = ({ activeTab }) => {
  const [subjects, setSubjects] = useState([]);
  const [types, setTypes] = useState([]);
  const [typeName, setTypeName] = useState("");
  const [subjectName, setSubjectName] = useState("");
  const [subjectType, setSubjectType] = useState("");

  const fetchSubjects = async () => {
    try {
      const res = await axios.get('/api/subj/adminpredmeti');
      setSubjects(res.data);
    } catch (err) {
      console.error('Error fetching subjects:', err);
    }
  };

  const fetchTypes = async () => {
    try {
      const res = await axios.get('/api/subj/admintipovi');
      setTypes(res.data);
    } catch (err) {
      console.error('Error fetching types:', err);
    }
  };


  useEffect(() => {
    if (activeTab === 'subjects') {
      fetchSubjects();
       fetchTypes();
    }
  }, [activeTab]);

  const handleSubmit = (e) => {
    e.preventDefault();

    if (!subjectName.trim() || !subjectType) {
      Swal.fire({
        title: 'Greška!',
        text: 'Molimo unesite naziv predmeta i odaberite tip.',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    Swal.fire({
      title: 'Da li ste sigurni?',
      text: `Želite da dodate ovaj predmet?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Da, potvrdite!',
      cancelButtonText: 'Otkaži'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post('/api/subj/insertSubject', {
            naziv_predmeta: subjectName,
            tip: subjectType
          });

          fetchSubjects();

          Swal.fire(
            'Uspješno!',
            'Predmet je dodat.',
            'success'
          );
        } catch (err) {
          console.error('Error adding subject:', err);
          Swal.fire('Greška!', 'Došlo je do greške prilikom dodavanja predmeta.', 'error');
        }
      }
    });

    setSubjectName("");
    setSubjectType("");
  };

    const handleSubmit2 = (e) => {
    e.preventDefault();

    if (!typeName.trim()) {
      Swal.fire({
        title: 'Greška!',
        text: 'Molimo unesite naziv kategorije!',
        icon: 'error',
        confirmButtonText: 'OK'
      });
      return;
    }

    Swal.fire({
      title: 'Da li ste sigurni?',
      text: `Želite da dodate ovu kategoriju`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Da, potvrdite!',
      cancelButtonText: 'Otkaži'
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          await axios.post('/api/subj/insertType', {
            naziv_tipa: typeName,
          });

          fetchSubjects();

          Swal.fire(
            'Uspješno!',
            'Kategorija je dodata.',
            'success'
          );
        } catch (err) {
          console.error('Error adding subject:', err);
          Swal.fire('Greška!', 'Došlo je do greške prilikom dodavanja kategorije.', 'error');
        }
      }
    });
    setTypeName("");
  };

  const handleDeleteSubject = async (id_predmeta) => {
    Swal.fire({
      title: "Da li ste sigurni?",
      text: "Ova akcija će trajno obrisati predmet!",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Da, obriši!",
      cancelButtonText: "Otkaži"
    }).then(async (result) => {
      if (result.isConfirmed) {
        try {
          const res = await axios.post(
            "/api/subj/deleteSubject",
            { id_predmeta },
            { withCredentials: true }
          );

          if (res.status === 200) {
            Swal.fire({
              title: "Uspješno!",
              text: "Predmet je uspješno obrisan.",
              icon: "success",
              timer: 2000,
              showConfirmButton: false
            });

            fetchSubjects();
          }
        } catch (err) {
          console.error("Greška prilikom brisanja predmeta:", err);

          Swal.fire({
            title: "Greška!",
            text: err.response?.data?.message || "Došlo je do greške prilikom brisanja predmeta.",
            icon: "error"
          });
        }
      }
    });
  };

  return (
    <div>
      <p>Dodaj tip(kategoriju)</p>
      <form onSubmit={handleSubmit2} className='d-flex align-items-center justify-content-center'>
        <label className="block">Naziv:</label>
        <input
          type="text"
          value={typeName}
          onChange={(e) => setTypeName(e.target.value)}
          className="p-2 border rounded mx-2"
          placeholder="Unesite naziv"
        />
        <button
          type="submit"
          className="btn btn-primary p-2"
        >
          Dodaj tip
        </button>
      </form>


      <p>Dodaj predmet</p>
      <form onSubmit={handleSubmit} className='d-flex align-items-center justify-content-center'>
        <label className="block">Naziv predmeta:</label>
        <input
          type="text"
          value={subjectName}
          onChange={(e) => setSubjectName(e.target.value)}
          className="p-2 border rounded mx-2"
          placeholder="Unesite naziv"
        />

        <label className="block">Tip predmeta:</label>
          <select
            value={subjectType}
            onChange={(e) => setSubjectType(e.target.value)}
            className="p-2 border rounded mx-2"
          >
            <option value="">Izaberite tip</option>
            {types.map((type) => (
              <option key={type.id} value={type.id}>
                {type.naziv}
              </option>
            ))}
          </select>


        <button
          type="submit"
          className="btn btn-primary p-2"
        >
          Dodaj predmet
        </button>
      </form>
      <p>Pregled predmeta</p>
      
      <AdminSearch/>

      <table>
        <thead>
          <tr>
            <th>ID Predmeta</th>
            <th>Naziv</th>
            <th>Tip</th>
            <th>Broj predavača osnovna</th>
            <th>Broj predavača srednja</th>
            <th>Broj predavača fakultet</th>
            <th>Izbrisi predmet</th>
          </tr>
        </thead>
        <tbody style={{ color: 'white' }}>
          {subjects.map((subject) => (
            <tr key={subject.id_predmeta} style={{
              backgroundColor:
                subject.broj_profesora_osnovna > 0 &&
                  subject.broj_profesora_srednja > 0 &&
                  subject.broj_profesora_fakultet > 0 ? '#28a745' :
                  subject.broj_profesora_osnovna > 0 ||
                    subject.broj_profesora_srednja > 0 ||
                    subject.broj_profesora_fakultet > 0 ? '#F99247' :
                    'grey'
            }}>

              <td>{subject.id_predmeta}</td>
              <td>{subject.naziv_predmeta}</td>
              <td>{subject.tip_predmeta}</td>
              <td>{subject.broj_profesora_osnovna}</td>
              <td>{subject.broj_profesora_srednja}</td>
              <td>{subject.broj_profesora_fakultet}</td>
              <td><button className='btn btn-danger' onClick={() => handleDeleteSubject(subject.id_predmeta)} >Izbrisi predmet</button></td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default AdminSubjects;